import PropTypes from 'prop-types';
import React, { Component } from 'react';
import getCertificateInfoFields from './private/getCertificateInfoFields';

export default class CertificateInfo extends Component {
  static propTypes = {
    certificateInfo: PropTypes.instanceOf(Map).isRequired,
    signType: PropTypes.string.isRequired,
  };

  getItems() {
    const { certificateInfo, signType } = this.props;
    return getCertificateInfoFields(certificateInfo.get('data'), signType).map((field, index) => {
      return (
        <div className="profile_item text-big" key={`_info_${index}`}>
          <div className="cRow">
            <div className="cCol cCol__50 grey">{field.title}</div>
            <div className="cCol cCol__50">{field.value}</div>
          </div>
        </div>
      );
    });
  }

  render() {
    return (
      <div>
        <div className="js-check-block">
          <h4 className="page_margin30">Просмотр реквизитов сертификата</h4>
          {this.getItems()}
        </div>
      </div>
    );
  }
}
